import { Section } from '@tracklib/kit'
import styles from './articlequoteblock.css'

type Props = {
  value: {
    text: string
    author: string
  }
}

const ArticleQuoteBlock = ({ value: { text, author } }: Props): JSX.Element => (
  <Section size="small">
    <div className={styles.container}>
      <em />
      <p>{text}</p>
      {author && <span>{author}</span>}
    </div>
  </Section>
)

export default ArticleQuoteBlock
